module.exports = __webpack_public_path__ + "static/media/combat(19).d56c4ad5.PNG";